import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent, TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import { Button, FormControlLabel, TextField, Hidden, MenuItem, Radio, Icon, Checkbox, Typography, IconButton } from 'material-ui';
import ReactTable from "react-table";
import axios from 'axios';
import { bindActionCreators } from 'redux';
import { Tab, Tabs } from 'material-ui';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import $ from "jquery";
import { withAlert } from 'react-alert';
import Tooltip from 'material-ui/Tooltip';

const styles = theme => ({
    layoutRoot: {}
});

var editEmpId = null;
var editEmpRegId = null;
var editNic = null;
var editFirstName = null;
var editLastName = null;
var editSalaryId = null;
var editAppoimentData = null;
var editProbationPeriod = null;
var editDepartment = null;
var editDesignation = null;
var editGreade = null;
var editEmployeement = null;
var editPermentShift = null;
var editBasicSalary = null;
var editPaymentMethod = null;
var editTimeCategory = null;
var editEmployeeStatus = null;
var yr = null;
var month = null;
var day = null;

var deleteEmpId = null;
var deleteFirstName = null;
var deleteLastName = null;

class Tab3LoadEmployeeSalaryDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            data: [],
            loadDepartmentTypes: [],
            loadDesignationTypes: [],
            loadEmployementTypes: [],
            loadPaymentTypes: [],
            loadTimeCategoryTypes: [],

            nicEdit: ""
        };

        this.loadEmployeeSalaryDetails();
        this.loadDepartmentTypes();
        this.loadDesignationTypes();
        this.loadEmployementTypes();
        this.loadPaymentTypes();
        this.loadTimeCategoryTypes();
    }

    // Edit Statement
    stateEdit = {
        canEdit: false
    };

    handleClickOpenEdit = () => {
        this.setState({ edit: true });
    };

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };

    addhandleClickOpen = () => {
        this.setState({ add: true });
    };

    addhandleClose = () => {
        this.setState({ add: false });
    };

    // edit employee personal details
    onEdit = (model) => {

        this.editEmployeeSalaryDetail(model);
    };

    onDelete = (model) => {
        this.deleteEmployeeSalaryDetail(model);
    };

    // Delete Statement
    handleClickDelete = () => {
        // alert(e.value);
        this.setState({ delete: true });
    };

    handleCloseDelete = () => {
        this.setState({ delete: false });
    };

    disableButtonDelete = () => {
        this.setState({ canEdit: false });
    };

    enableButtonDelete = () => {
        this.setState({ canEdit: true });
    };

    // load employee department types
    loadDepartmentTypes() {
        var loadDepartmentTypes = [];

        axios.get(window.systemServer+'/system/loadDepartment')
            .then(response => {

                for (let i = 0; i < response.data.length; i++) {
                    loadDepartmentTypes.push({
                        value: response.data[i].department_name
                    });
                }
                this.setState({ loadDepartmentTypes: loadDepartmentTypes });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    //load designation types methos 
    loadDesignationTypes() {
        var loadDesignationTypes = [];

        axios.get(window.hrmServer+'/getDesignation')
            .then(response => {
                if (response.data.success) {
                    // alert('Success'+response.data.result[0].DESIGNATION);
                    var designationObj = response.data.result;
                    // console.log("peeen "+employeeObj[31].PROFILE_IMAGE);

                    for (var i = 0; i < designationObj.length; i++) {

                        loadDesignationTypes.push({
                            value: designationObj[i].DESIGNATION
                        });
                    }
                }
                this.setState({ loadDesignationTypes: loadDesignationTypes });

            }).catch(function (error) {
                // alert(error);
                console.log("designation err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    //load employeement types 
    loadEmployementTypes() {
        var loadEmployementTypes = [];

        axios.get(window.systemServer+'/system/loadContarctType')
            .then(response => {
                console.log("Contract : " + response.data[0].contarct_type);
                for (let i = 0; i < response.data.length; i++) {
                    loadEmployementTypes.push({
                        value: response.data[i].contarct_type
                    });
                }
                this.setState({ loadEmployementTypes: loadEmployementTypes });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    //load payment methos 
    loadPaymentTypes() {
        var loadPaymentTypes = [];

        axios.get(window.systemServer+'/system/loadPaymentType')
            .then(response => {

                for (let i = 0; i < response.data.length; i++) {
                    loadPaymentTypes.push({
                        value: response.data[i].payment_type
                    });
                }
                this.setState({ loadPaymentTypes: loadPaymentTypes });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    //load paymet types methos 
    loadTimeCategoryTypes() {
        var loadTimeCategoryTypes = [];

        axios.get(window.systemServer+'/system/loadDurationType')
            .then(response => {

                for (let i = 0; i < response.data.length; i++) {
                    loadTimeCategoryTypes.push({
                        value: response.data[i].duration_type
                    });
                }
                this.setState({ loadTimeCategoryTypes: loadTimeCategoryTypes });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    // load employee salary details 
    loadEmployeeSalaryDetails() {

        axios.get(window.hrmServer+'/getEmployeeSalaryDetails')
            .then(response => {
                if (response.data.success) {
                    // alert('Success');
                    var employeeObj = response.data.result;

                    this.appendToTable(employeeObj);
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        this.handleCloseEdit();

    }

    // append data into table
    appendToTable(employeeObj) {
        var data = [];
        // console.log("peeen " + employeeObj[31].PROFILE_IMAGE);

        for (var i = 0; i < employeeObj.length; i++) {
            
            var appoimetD = '';
            if(null == employeeObj[i].APPOIMENT_DATE || undefined == employeeObj[i].APPOIMENT_DATE || '' == employeeObj[i].APPOIMENT_DATE){
                appoimetD = '';
            }else{
                appoimetD = (employeeObj[i].APPOIMENT_DATE).split('T')[0];
            }

            data.push({

                empId: employeeObj[i].ID_EMPLOYEE_PROFILE,
                // empRegId: employeeObj[i].ID_EMPLOYEE_REGISTRY,
                salaryId: employeeObj[i].ID_SALARY_DETAIL,
                // nic: employeeObj[i].NIC,
                // firstName: employeeObj[i].FIRST_NAME,
                // lastName: employeeObj[i].LAST_NAME,
                appoimentDate: appoimetD,
                probetaionPeriod: employeeObj[i].PROBATION_PERIOD,
                department: employeeObj[i].DEPERTMENT,
                designation: employeeObj[i].DESIGNATION,
                greade: employeeObj[i].GREADE,
                employement: employeeObj[i].EMPLOYEMENT,
                permenatShift: employeeObj[i].PERMENT_SHIFT,
                basicSalary: employeeObj[i].BASIC_SALARY,
                paymentMethod: employeeObj[i].PAYMENT_METHOD,
                timeCategory: employeeObj[i].TIME_CATEGORY,
                employeeStatus: employeeObj[i].EMPLOYE_STATUS
            });

        }
        this.setState({ data: data });
    }

    // get employee details for load salary detail identify
    getEmployeDetails(editEmpId) {

        var searchObj = {
            searchval: editEmpId
        }
        axios.post(window.hrmServer+'/searchEmployeePersnolDatail', searchObj)
            .then(res => {

                // alert(res.data.success);
                if (res.data.success) {
                    // this.props.alert.success("Salary Details Updated Successfully");
                    var searchObj = res.data.resultSearch;
                    editEmpRegId = searchObj[0].ID_EMPLOYEE_REGISTRY;
                    editFirstName = searchObj[0].FIRST_NAME;
                    editNic = searchObj[0].NIC;
                    this.setState({ nicEdit: editNic });
                } else {
                    this.props.alert.error("Unable to Update Please Check !");
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                this.props.alert.error("No internet connection or Internal error");
            });

    }


    // updete employee salary details
    editEmployeeSalaryDetail(model) {
        var editEmpSalaryDetail = {
            editEmpId: model.editEmpId,
            editSalaryId: model.editSalaryId,
            editAppoinmentDate: model.editAppoinmentDate,
            editProbationPeriod: model.editProbationPeriod,
            editDepartment: model.editDepartment,
            editDesignation: model.editDesignation,
            editEmployeement: model.editEmployeement,
            editPermentShift: model.editPermentShift,
            editGreade: model.editGreade,
            editBasicSalary: model.editBasicSalary,
            editPaymentMethod: model.editPaymentMethod,
            editTimeCategory: model.editTimeCategory
        }

        // neeed to create edit employee persnol data servise
        axios.post(window.hrmServer+'/editEmployeeSalaryDatail', editEmpSalaryDetail)
            .then(res => {

                // alert(res.data.success);
                if (res.data.success) {
                    this.props.alert.success("Salary Details Updated Successfully");

                    this.handleCloseEdit();
                    this.loadEmployeeSalaryDetails();
                } else {
                    this.props.alert.error("Unable to Update Please Check !");
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                this.props.alert.error("No internet connection or Internal error");
            });
    }

    // delete employee salary details
    deleteEmployeeSalaryDetail(model) {
        var employeeId = model.deleteEmpId;

        if (null == employeeId || "" == employeeId || undefined == employeeId) {

            this.props.alert.error("Cannot Delete This Salary Detail !");

        } else {

            var deleteObj = {
                employeeId: employeeId
            }

            axios.post(window.hrmServer+'/deleteEmployee', deleteObj)
                .then(response => {

                    if (response.data.success) {

                        this.props.alert.success("Salary Detail Deleted Successfully");

                        this.handleCloseDelete();
                        this.loadEmployeeSalaryDetails();
                    } else {
                        this.props.alert.error("Unable to Deleted Please Check !");
                    }
                }).catch(function (error) {
                    alert("Error");
                    console.log("No internet connection or Internal error");
                    this.props.alert.error("No internet connection or Internal error !");
                });
        }
    }

    render() {
        return (
            <div className="w-full">
                <ReactTable className="w-full"
                    getTrProps={(state, rowInfo, column) => {
                        return {
                            className: "cursor-pointer",
                            onClick: (e, handleOriginal) => {

                            }
                        }
                    }}
                    data={this.state.data}
                    columns={[

                        {
                            Header: "Emp Id",
                            accessor: "empId",
                            show: false
                        },
                        // {
                        //     Header: "Emp Reg",
                        //     accessor: "empRegId",
                        //     show: false
                        // },

                        {
                            Header: "Salary Id",
                            accessor: "salaryId",
                            show: false
                        },
                        // {
                        //     Header: "NIC Id",
                        //     accessor: "nic",
                        //     show: false
                        // },
                        // {
                        //     Header: "Firstanem",
                        //     accessor: "firstName",
                        //     show: false
                        // },
                        // {
                        //     Header: "lastnmae",
                        //     accessor: "lastName",
                        //     show: false
                        // },

                        {
                            Header: "Appointment Date",
                            accessor: "appoimentDate",
                            filterable: true

                        },
                        // {
                        //     Header: "Porbation Period(months)",
                        //     accessor: "probetaionPeriod",
                        //     filterable: true

                        // },
                        {
                            Header: "Department",
                            accessor: "department",
                            filterable: true

                        },
                        {
                            Header: "Designation",
                            accessor: "designation",
                            filterable: true

                        },
                        {
                            Header: "Greade",
                            accessor: "greade",
                            filterable: true

                        },
                        // {
                        //     Header: "Employement",
                        //     accessor: "employement",
                        //     filterable: true

                        // },
                        // {
                        //     Header: "Permenat Shift",
                        //     accessor: "permenatShift",
                        //     filterable: true

                        // },
                        {
                            Header: "Basic Salary",
                            accessor: "basicSalary",
                            filterable: true

                        },
                        // {
                        //     Header: "Payment Method",
                        //     accessor: "paymentMethod",
                        //     filterable: true

                        // },
                        // {
                        //     Header: "Time Category",
                        //     accessor: "timeCategory",
                        //     filterable: true

                        // },
                        // {
                        //     Header: "Employee Status",
                        //     accessor: "employeeStatus",
                        //     filterable: true

                        // },

                        {
                            Header: "Action",
                            // accessor: "su",
                            width: 128,
                            Cell: row => (
                                <div className="flex items-center w-8 h-8">

                                    <Tooltip
                                        enterDelay={300}
                                        id="tooltip-controlled"
                                        leaveDelay={300}
                                        onClose={this.handleTooltipClose}
                                        onOpen={this.handleTooltipOpen}
                                        open={this.state.open}
                                        placement="bottom"
                                        title="Edit employee salary details"
                                    >

                                        <IconButton

                                            onClick={(e) => {
                                                if (row) {

                                                    editEmpId = row.original.empId;
                                                    // editEmpRegId = row.original.empRegId;
                                                    editSalaryId = row.original.salaryId;
                                                    // editNic = row.original.nic;
                                                    // editFirstName = row.original.firstName;
                                                    // editLastName = row.original.lastName;

                                                    editAppoimentData = new Date(row.original.appoimentDate),
                                                    yr = editAppoimentData.getFullYear(),
                                                    month = (editAppoimentData.getMonth()+1)
                                                    month = month < 10 ? '0' + month : month,
                                                    day = editAppoimentData.getDate() < 10 ? '0' + editAppoimentData.getDate() : editAppoimentData.getDate(),
                                                    editAppoimentData = yr + '-' + month + '-' + day;

                                                    editProbationPeriod = row.original.probetaionPeriod;
                                                    editDepartment = row.original.department;
                                                    editDesignation = row.original.designation;
                                                    editGreade = row.original.greade;
                                                    editEmployeement = row.original.employement;
                                                    editPermentShift = row.original.permenatShift;
                                                    editBasicSalary = row.original.basicSalary;
                                                    editPaymentMethod = row.original.paymentMethod;
                                                    editTimeCategory = row.original.timeCategory;
                                                    editEmployeeStatus = row.original.employeeStatus;

                                                    this.getEmployeDetails(editEmpId);
                                                    // alert(this.state.nicEdit);
                                                    this.setState({ edit: true });
                                                }
                                            }}

                                        >
                                            <Icon className="text-blue">mode_edit</Icon>
                                        </IconButton>
                                    </Tooltip>

                                    {/* ///// */}

                                    <Dialog

                                        open={this.state.edit}
                                        onClose={this.handleCloseEdit}
                                        aria-labelledby="form-dialog-title"
                                    >
                                        <Formsy
                                            onValidSubmit={this.onEdit}
                                            onValid={this.enableButtonEdit}
                                            onInvalid={this.disableButtonEdit}
                                            ref={(form) => this.form = form}
                                            className=""
                                        >
                                            <DialogTitle id="form-dialog-title">Edit Salary Details</DialogTitle>
                                            <DialogContent className="flex flex-wrap">

                                                <div className="w-full">

                                                    <TextFieldFormsy
                                                        type="hidden"
                                                        name="editEmpId"
                                                        value={editEmpId}
                                                    />

                                                    <TextFieldFormsy
                                                        type="hidden"
                                                        name="editEmpRegId"
                                                        value={editEmpRegId}
                                                    />

                                                    <TextFieldFormsy
                                                        type="hidden"
                                                        name="editSalaryId"
                                                        value={editSalaryId}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-1/3 pr-8"
                                                        type="text"
                                                        name="editEmpCode"
                                                        label="Employee ID"
                                                        value={'EMP' + editEmpRegId}
                                                        required
                                                        disabled={true}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-1/3 pr-8"
                                                        type="text"
                                                        name="editNic"
                                                        label="NIC No"
                                                        value={editNic}
                                                        disabled={true}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-1/3"
                                                        type="text"
                                                        name="editFirstName"
                                                        label="First Name"
                                                        value={editFirstName}
                                                        disabled={true}
                                                    />
                                                </div>

                                                <div className="w-full">
                                                    <TextFieldFormsy
                                                        // id="date"
                                                        label="Appoinment Date"
                                                        name="editAppoinmentDate"
                                                        type="date"
                                                        // defaultValue={editAppoimentData}
                                                        value={editAppoimentData}
                                                        className="{classes.textField} w-full md:w-1/4 mt-8 pr-8"
                                                        required
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />

                                                    <TextFieldFormsy
                                                        label="Probation Period"
                                                        type="number"
                                                        name="editProbationPeriod"
                                                        id="simple-start-adornment"
                                                        className="{classNames(classes.margin, classes.textField)} w-full md:w-1/4 mt-8 pr-8"
                                                        value={editProbationPeriod}
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">Months</InputAdornment>,
                                                        }}
                                                    />

                                                    <SelectFormsy
                                                        className="w-full md:w-1/2  mt-16 pr-24"
                                                        name="editDepartment"
                                                        label="Department"
                                                        value={editDepartment}
                                                    >
                                                        <MenuItem className="popup-value-size" disabled value={editDepartment}>
                                                            <em>{editDepartment}</em>
                                                        </MenuItem>
                                                        {this.state.loadDepartmentTypes.map(function (item, i) {
                                                            return <MenuItem className="popup-value-size" value={item.value}>{item.value}</MenuItem>;
                                                        })}
                                                    </SelectFormsy>

                                                </div>

                                                <div className="w-full">
                                                    <SelectFormsy
                                                        className="w-full md:w-1/2  mt-16 pr-24"
                                                        name="editDesignation"
                                                        label="Designation"
                                                        value={editDesignation}
                                                    >
                                                        <MenuItem className="popup-value-size" disabled value={editDesignation}>
                                                            <em>{editDesignation}</em>
                                                        </MenuItem>
                                                        {this.state.loadDesignationTypes.map(function (item, i) {
                                                            return <MenuItem className="popup-value-size" value={item.value}>{item.value}</MenuItem>;
                                                        })}
                                                    </SelectFormsy>

                                                    <SelectFormsy
                                                        className="w-full md:w-1/2  mt-16 pr-24"
                                                        name="editEmployeement"
                                                        label="Employeement"
                                                        value={editEmployeement}
                                                    >
                                                        <MenuItem className="popup-value-size" disabled value={editEmployeement}>
                                                            <em>{editEmployeement}</em>
                                                        </MenuItem>
                                                        {this.state.loadEmployementTypes.map(function (item, i) {
                                                            return <MenuItem className="popup-value-size" value={item.value}>{item.value}</MenuItem>;
                                                        })}
                                                    </SelectFormsy>
                                                </div>

                                                <div className="w-full">
                                                    <SelectFormsy
                                                        className="w-full md:w-1/3 pr-8 mt-16"
                                                        name="editPermentShift"
                                                        label="Premenent Shift"
                                                        value={editPermentShift}
                                                    >
                                                        <MenuItem className="popup-value-size" disabled value={editPermentShift}>
                                                            <em>{editPermentShift}</em>
                                                        </MenuItem>
                                                        <MenuItem className="popup-value-size" value="day">Day</MenuItem>
                                                        <MenuItem className="popup-value-size" value="night">Night</MenuItem>
                                                    </SelectFormsy>

                                                    <SelectFormsy
                                                        className="w-full md:w-1/3  mt-16 pr-24"
                                                        name="editGreade"
                                                        label="Greade"
                                                        value={editGreade}
                                                    >
                                                        <MenuItem className="popup-value-size" value={editGreade}>
                                                            <em>{editGreade}</em>
                                                            {/* Title */}
                                                        </MenuItem>
                                                        <MenuItem className="popup-value-size" value="1">1</MenuItem>
                                                        <MenuItem className="popup-value-size" value="2">2</MenuItem>
                                                        <MenuItem className="popup-value-size" value="3">3</MenuItem>
                                                        <MenuItem className="popup-value-size" value="4">4</MenuItem>
                                                        <MenuItem className="popup-value-size" value="5">5</MenuItem>
                                                    </SelectFormsy>

                                                    <TextFieldFormsy
                                                        label="Basic Salary"
                                                        type="number"
                                                        name="editBasicSalary"
                                                        id="simple-start-adornment"
                                                        value={editBasicSalary}
                                                        className="{classNames(classes.margin, classes.textField)} w-full md:w-1/3 mt-16 pr-24"
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">LKR</InputAdornment>,
                                                        }}
                                                    />
                                                </div>

                                                <div className="w-full">
                                                    <SelectFormsy
                                                        className="w-full md:w-1/2  mt-16 pr-24"
                                                        name="editPaymentMethod"
                                                        label="Payment Method"
                                                        value={editPaymentMethod}
                                                    >
                                                        <MenuItem className="popup-value-size" disabled value={editPaymentMethod}>
                                                            <em>{editPaymentMethod}</em>
                                                        </MenuItem>
                                                        {this.state.loadPaymentTypes.map(function (item, i) {
                                                            return <MenuItem className="popup-value-size" value={item.value}>{item.value}</MenuItem>;
                                                        })}
                                                    </SelectFormsy>

                                                    <SelectFormsy
                                                        className="w-full md:w-1/2  mt-16 pr-24"
                                                        name="editTimeCategory"
                                                        label="Time Category"
                                                        value={editTimeCategory}
                                                    >
                                                        <MenuItem className="popup-value-size" disabled value={editTimeCategory}>
                                                            <em>{editTimeCategory}</em>
                                                        </MenuItem>
                                                        {this.state.loadTimeCategoryTypes.map(function (item, i) {
                                                            return <MenuItem className="popup-value-size" value={item.value}>{item.value}</MenuItem>;
                                                        })}
                                                    </SelectFormsy>
                                                </div>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button type="button" onClick={this.handleCloseEdit} variant="raised" size="small" color="primary" className="{classes.button} w-full  md:h-24">
                                                    Close
                                                    </Button>

                                                <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:h-24 ">
                                                    Update
                                                    </Button>
                                            </DialogActions>
                                        </Formsy>
                                    </Dialog>
                                    {/* ///// */}


                                    {/* <IconButton
                                        onClick={(e) => {
                                            if (row) {

                                                deleteEmpId = row.original.empId;
                                                deleteFirstName = row.original.firstName;
                                                deleteLastName = row.original.lastName;
                                                this.setState({ delete: true });
                                            }
                                        }}
                                    >
                                        <Icon className="text-red-light">delete</Icon>
                                    </IconButton> */}


                                    {/* ///// */}

                                    {/* <Dialog
                                        open={this.state.delete}
                                        onClose={this.handleClose}
                                        aria-labelledby="form-dialog-title"
                                    >
                                        <DialogTitle id="form-dialog-title">Delete Employee</DialogTitle>
                                        <DialogContent>

                                            <div>
                                                <Formsy
                                                    onValidSubmit={this.onDelete}
                                                    onValid={this.enableButtonDelete}
                                                    onInvalid={this.disableButtonDelete}
                                                    ref={(form) => this.form = form}
                                                    className="flex flex-col justify-center"
                                                >
                                                    <TextFieldFormsy
                                                        type="hidden"
                                                        name="deleteEmpId"
                                                        value={deleteEmpId}
                                                    />

                                                    <div className="w-full">
                                                        Are you sure delete <h4>{deleteFirstName + " " + deleteLastName + " ?"}</h4>
                                                    </div>

                                                    <DialogActions>
                                                        <Button onClick={this.handleCloseDelete} color="primary">
                                                            Cancel
                                                                </Button>
                                                        <Button color="primary" autoFocus
                                                            type="submit"
                                                        >
                                                            Delete
                                                        </Button>

                                                    </DialogActions>
                                                </Formsy>
                                            </div>
                                        </DialogContent>


                                    </Dialog> */}

                                    {/* ///// */}


                                </div>
                            )
                        }

                    ]}
                    defaultPageSize={10}
                    className="-striped -highlight"
                />

            </div>
        );
    }
}

export default withStyles(styles, { withTheme: true })(withAlert(Tab3LoadEmployeeSalaryDetails));



// WEBPACK FOOTER //
// ./src/main/content/hr/viewEmployee/components/Tab3LoadEmployeeSalaryDetails.js